import { Component, OnInit } from '@angular/core';
import {
  ITagsWebServiceClient,
  RechercherDossierBloqueFilterDto
} from "@common/resources/resources";
import {ActivatedRoute} from "@angular/router";
import {ArianeElement, ArianeStore, UserStore} from "@digicerba/common";

@Component({
  selector: 'app-dossier-bloques',
  templateUrl: './dossier-bloques.component.html',
})
export class DossierBloquesComponent implements OnInit {

  hasTags: boolean;
  isAdmin: boolean;
  rechercherDossierBloqueFilterDto: RechercherDossierBloqueFilterDto;

  constructor(private arianeStore: ArianeStore,
              private route: ActivatedRoute,
              private userStore: UserStore,
              private iTagsWebServiceClient: ITagsWebServiceClient) {
    let arianeElements: Array<ArianeElement>;
    arianeElements = [
      {
        libelle: "ARIANE.titre",
        route: ""
      },
    ];

    this.arianeStore.updateElements(arianeElements);
  }

  ngOnInit() {


    this.hasTags = this.route.parent.snapshot.data['access'] || this.userStore.isAdmin();

    this.iTagsWebServiceClient.isFormulaireDematAdminEnabled().subscribe(result => {
        this.isAdmin = result;
      },
      error => {

      });
  }



  onFiltering(rechercherDossierBloqueFilterDto: RechercherDossierBloqueFilterDto) {
    this.rechercherDossierBloqueFilterDto = rechercherDossierBloqueFilterDto;
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-formulaire-demat/digicerba-formulaire-demat-web/src/angular/cerba/src/app/pages/cerba/pages/dossier-bloques/dossier-bloques.component.ts